export default "__VITE_ASSET__BH3s2oZQ__"